import { BFPageHeader } from '../../components/BFPageHeader/BFPageHeader';
import { BFFilterBar } from '../../components/BFFilterBar/BFFilterBar';
import { BFFilterSearch } from '../../components/BFFilterSearch/BFFilterSearch';
import { BFFilterSelect } from '../../components/BFFilterSelect/BFFilterSelect';
import { BFTable } from '../../components/BFTable';
import { CompanyDetailDrawer } from './CompanyDetailDrawer/CompanyDetailDrawer';
import useCompanies from './useCompanies';
import type { CompanySize } from '../../constants/enums';
import './CompaniesPage.css';

export default function CompaniesPage() {
    const {
        rows,
        columns,
        total,
        page,
        pageSize,
        pageSizeOptions,
        isFetching,
        isLoadMoreFetching,
        sortConfig,
        tableFilterConfig,
        activeFilterCount,
        searchValue,
        selectedSizes,
        sizeOptions,
        setSearchValue,
        setSelectedSizes,
        handleReset,
        handleSort,
        handlePageChange,
        handleLoadMore,
        handleTableFilter,
        selectedRowKeys,
        setSelectedRowKeys,
        selectedCompanyId,
        setSelectedCompanyId,
        handleRowClick,
        t,
    } = useCompanies();

    return (
        <div className="companies-page">
            <BFPageHeader
                title={t('companies.title')}
                breadcrumbs={[{ label: t('menu.home'), path: '/' }, { label: t('companies.title') }]}
            />
            <BFFilterBar
                activeCount={activeFilterCount}
                matchCount={total}
                matchLabel={t('companies.listOfMatches')}
                onReset={activeFilterCount > 0 ? handleReset : undefined}
            >
                <BFFilterSearch
                    placeholder={t('companies.searchByIdVat')}
                    value={searchValue}
                    onChange={(val) => setSearchValue(val)}
                    onClear={() => setSearchValue('')}
                />
                <BFFilterSelect<CompanySize>
                    options={sizeOptions}
                    value={selectedSizes}
                    onChange={(val) => setSelectedSizes(val as CompanySize[])}
                    multiSelect
                    placeholder={t('companies.allSizes')}
                />
            </BFFilterBar>
            <div className="companies-page__table-wrapper">
                <BFTable
                    columns={columns}
                    dataSource={rows}
                    rowKey="id"
                    loading={isFetching}
                    serverSide
                    selectable
                    selectedRowKeys={selectedRowKeys}
                    onSelectionChange={(keys) => setSelectedRowKeys(keys)}
                    draggable
                    stickyHeader
                    size="small"
                    sortConfig={sortConfig}
                    onSort={handleSort}
                    filterConfig={tableFilterConfig}
                    onFilterSet={handleTableFilter}
                    pagination={{
                        currentPage: page,
                        pageSize,
                        total,
                        pageSizeOptions,
                    }}
                    onPaginationChange={handlePageChange}
                    loadMore={{
                        pageSize,
                        total,
                        loadedCount: rows.length,
                    }}
                    onLoadMore={handleLoadMore}
                    loadMoreLoading={isLoadMoreFetching}
                    onRowClick={handleRowClick}
                    emptyText={t('errors.companyNotFound')}
                />
            </div>
            <CompanyDetailDrawer companyId={selectedCompanyId} onClose={() => setSelectedCompanyId(null)} />
        </div>
    );
}
